// -- copyright
// OpenProject is a project management system.
// Copyright (C) 2012-2015 the OpenProject Foundation (OPF)
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See doc/COPYRIGHT.rdoc for more details.
// ++

import {WorkPackageCacheService} from 'core-components/work-packages/work-package-cache.service';
import {HalResourceNotificationService} from "core-app/modules/hal/services/hal-resource-notification.service";
import {States} from 'core-components/states.service';
import {
  displayClassName,
  DisplayFieldRenderer,
  editFieldContainerClass
} from 'core-components/wp-edit-form/display-field-renderer';

import {HalResourceEditingService} from "core-app/modules/fields/edit/services/hal-resource-editing.service";
import {SelectionHelpers} from '../../../../helpers/selection-helpers';
import {debugLog} from '../../../../helpers/debug_output';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {ConfigurationService} from 'core-app/modules/common/config/configuration.service';
import {OPContextMenuService} from "core-components/op-context-menu/op-context-menu.service";
import {NotificationsService} from 'core-app/modules/common/notifications/notifications.service';
import {I18nService} from 'core-app/modules/common/i18n/i18n.service';
import {IFieldSchema} from "core-app/modules/fields/field.base";
import {ClickPositionMapper} from "core-app/modules/common/set-click-position/set-click-position";
import {untilComponentDestroyed} from "ng2-rx-componentdestroyed";
import {EditFormComponent} from "core-app/modules/fields/edit/edit-form/edit-form.component";
import {HalResource} from "core-app/modules/hal/resources/hal-resource";
import { WorkPackageResource } from 'core-app/modules/hal/resources/work-package-resource';
import { HttpClient } from '@angular/common/http';
import { CurrentUserService } from "core-components/user/current-user.service";
@Component({
  selector: 'editable-attribute-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./editable-attribute-field.sass'],
  templateUrl: './editable-attribute-field.component.html'
})
export class EditableAttributeFieldComponent implements OnInit, OnDestroy {
  @Input('fieldName') public fieldName:string;
  @Input('resource') public resource:HalResource;
  @Input('wrapperClasses') public wrapperClasses?:string;
  @Input('displayFieldOptions') public displayFieldOptions:any = {};
  @Input('displayPlaceholder') public displayPlaceholder?:string;
  @Input('isDropTarget') public isDropTarget?:boolean = false;
  @Input('workPackageData') public workPackageData:WorkPackageResource;
  @Input() public is_project_admin:any
  @Input() public status:Array<any>
  @Input() public fieldLable:string
  @ViewChild('displayContainer', { static: true }) readonly displayContainer:ElementRef;
  @ViewChild('editContainer', { static: true }) readonly editContainer:ElementRef;

  public fieldRenderer:DisplayFieldRenderer;
  public editFieldContainerClass = editFieldContainerClass;
  public active = false;
  public isShowPlaceholder =[
    'description'
  ]
  private $element:JQuery;
  private currentUser: CurrentUserService = this.injector.get(CurrentUserService);

  public destroyed:boolean = false;

  constructor(protected states:States,
              protected injector:Injector,
              protected elementRef:ElementRef,
              protected halNotification:HalResourceNotificationService,
              protected ConfigurationService:ConfigurationService,
              protected opContextMenu:OPContextMenuService,
              protected halEditing:HalResourceEditingService,
              protected wpCacheService:WorkPackageCacheService,
              // Get parent field group from injector
              protected editForm:EditFormComponent,
              protected NotificationsService:NotificationsService,
              protected cdRef:ChangeDetectorRef,
              protected I18n:I18nService,
              private http: HttpClient) {

  }

  public requestHeader: any = {
    'X-Authentication-Scheme': 'Session',
    'X-Requested-With': 'XMLHttpRequest'
  };

  public setActive(active:boolean = true) {
    this.active = active;
    if (!this.destroyed) {
      this.cdRef.detectChanges();
    }
  }

  public ngOnInit() {

    this.fieldRenderer = new DisplayFieldRenderer(this.injector, 'single-view', this.displayFieldOptions);
    this.$element = jQuery(this.elementRef.nativeElement);
    this.editForm.register(this);

    this.halEditing
      .temporaryEditResource(this.resource)
      .values$()
      .pipe(
        untilComponentDestroyed(this)
      )
      .subscribe(workPackage => {
        this.resource = workPackage;
        this.render();
      });
  }

  public ngOnDestroy() {
    this.destroyed = true;
  }

  // Open the field when its closed and relay drag & drop events to it.
  public startDragOverActivation(event:JQuery.TriggeredEvent) {
    if (!this.isDropTarget || !this.isEditable || this.active) {
      return true;
    }

    this.handleUserActivate(null);
    event.preventDefault();
    return false;
  }

  public render() {
    //risc 处理 placeholder 不展示问题
    let placeholder =' '
    if(this.isShowPlaceholder.includes(this.fieldName)){
      placeholder =''
    }
    const el = this.fieldRenderer.render(this.resource, this.fieldName, null, placeholder);
    // console.log(el,'el',this.fieldName, this.displayPlaceholder)
    this.displayContainer.nativeElement.innerHTML = '';
    if(this.fieldName.includes('customField')) {
      el.style.borderStyle = 'none'
      // el.setAttribute('contenteditable', 'true')
      if(this.fieldName == 'customField44'){
        el.id = 'customField44'
        el.setAttribute('customField44_Time', this.resource.indexDate.all_sign_time.customField20)
      }
      
    } 
    this.displayContainer.nativeElement.appendChild(el);
  }

  public deactivate(focus:boolean = false) {
    this.editContainer.nativeElement.innerHTML = '';
    this.editContainer.nativeElement.hidden = true;
    this.setActive(false);

    if (focus) {
      setTimeout(() => this.$element.find(`.${displayClassName}`).focus(), 20);
    }
  }

  public get isEditable() {
    //console.log('??????????')
    const fieldSchema = this.resource.schema[this.fieldName] as IFieldSchema;
    return this.resource.isAttributeEditable(this.fieldName) && fieldSchema && fieldSchema.writable;
  }

  public activateIfEditable(event:JQuery.TriggeredEvent) {
      if((this.resource.type.name === 'RISC' || this.resource.type.name === 'RISC(inspection)' || this.resource.type.name === 'RISC(E&M)') && this.fieldName === 'subject'){
        return
      }
      if(this.fieldName === 'description'&&this.is_project_admin){
        console.log('管理员可以任意修改描述');
      }else{
        if(!this.status.find( (item:any) => {
          return item.id == this.resource.status.id
        }) && !this.is_project_admin&&!(this.resource.author.id == this.currentUser.userId&& this.resource.status.name == 'Submitted')) {
          this.NotificationsService.addError(this.I18n.t(
            'js.hal.error.edit_prohibited',
            {attribute: this.fieldLable}
          ));
          return
        }
      }
  
      // Ignore selections
      if (SelectionHelpers.hasSelectionWithin(event.target)) {
        debugLog(`Not activating ${this.fieldName} because of active selection within`);
        return true;
      }
    // Skip activation if the user clicked on a link or within a macro
    const target = jQuery(event.target);
    if (target.closest('a,macro', this.displayContainer.nativeElement).length > 0) {
      return true;
    }

    this.handleUserActivate(event);
    if (this.isEditable) {
      
    }

    this.opContextMenu.close();
    event.preventDefault();
    event.stopImmediatePropagation();

    return false;
  }

  public activateOnForm(noWarnings:boolean = false) {
    // Activate the field
    this.setActive(true);

    return this.editForm
      .activate(this.fieldName, noWarnings)
      .catch(() => this.deactivate(true));
  }

  public handleUserActivate(evt:JQuery.TriggeredEvent|null) {
    let positionOffset = 0;


    if (evt) {
      // Get the position where the user clicked.
      positionOffset = ClickPositionMapper.getPosition(evt);
    }
    if(this.workPackageData){
      this.http.get(`/api/v3/work_packages/${this.resource.id}`).subscribe((data:any)=>{
        //console.log(this.workPackageData,this.wrapperClasses)
        this.workPackageData.lockVersion = data.lockVersion
        
        this.activateOnForm()
        .then((handler) => {
          if (!handler) {
            return;
          }
  
          handler.$onUserActivate.next();
          handler.focus(positionOffset);
        });
      })
    }else{
      this.activateOnForm()
        .then((handler) => {
          if (!handler) {
            return;
          }
  
          handler.$onUserActivate.next();
          handler.focus(positionOffset);
        });
    }

    return false;
  }

  public reset() {
    this.render();
    this.deactivate();
  }

}
